import type { Vehicle } from './vehicle';

import { type ApiEntities, type ApiEntity, mapApiEntities, mapApiEntity } from '@/common/domain/api';

export interface Fleet {
    id?: number | string;
    documentId?: string;
    prefix?: string;
    name?: string;
    owner?: string;
    vehicles?: Vehicle[];
}

// ponytail: the backend fleet schema has no prefix/type field — the mobile app creates the personal
// fleet as "My vehicles" and identifies it by that name, so we do too. Switch if a real marker lands.
export const PERSONAL_FLEET_NAME = 'My vehicles';

export const isPersonalFleet = (fleet?: Fleet | null): boolean =>
    fleet?.name === PERSONAL_FLEET_NAME;

export interface ApiFleetAttributes {
    id?: number | string;
    documentId?: string;
    prefix?: string;
    name?: string;
    owner?: string;
    vehicles?: ApiEntities<Vehicle>;
    
}

const fleetToApiFleet = (fleet: Fleet): Fleet => {
    
    // Return only attributes that can be modified
    return {
        name: fleet.name,
        vehicles: fleet.vehicles
    };
};

const fleetsToApiFleets = (fleets: Fleet[]): Fleet[] => {
    return fleets.map((fleet) => fleetToApiFleet(fleet));
};

const apiFleetToFleet = (apiFleet: ApiEntity<ApiFleetAttributes>): Fleet => {
    // Map Strapi v5 flat entity to domain model
    const mapped = mapApiEntity<ApiFleetAttributes>(apiFleet);
    
    if (!mapped) {
        return null as unknown as Fleet;
    }

    const {
        prefix,
        name,
        owner,
        vehicles,
        id,
        documentId,
    } = mapped;

    return {
        documentId,
        id,
        name,
        owner,
        prefix,
        vehicles: mapApiEntities(vehicles),
    };
};

const apiFleetsToFleets = (data: ApiEntity<ApiFleetAttributes>[]): Fleet[] => {
    return data.map((apiFleet: ApiEntity<ApiFleetAttributes>) => apiFleetToFleet(apiFleet));
};


const useFleetConvertor = {
    apiFleetToFleet,
    apiFleetsToFleets,
    fleetToApiFleet,
    fleetsToApiFleets
};

export default useFleetConvertor;
